import { SegmentMode } from "./types"

export const mediaPlayingIntervalTime = 2

/* Core */
export const segmentMode: SegmentMode = "live"
